<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
            <div class="search-form">
                <Input :maxlength="100" v-model="searchForm.typeName" placeholder="请输入分类名称" />
                <div>
                    <Select style="width: 120px;" v-model="searchForm.typeStatus" placeholder="请选择状态" allow-clear>
                        <Option :value="1">启用</Option>
                        <Option :value="0">禁用</Option>
                    </Select>
                </div>
                <div>
                    <Select style="width: 140px;" v-model="searchForm.langId" placeholder="请选择语言">
                        <Option v-for="(item, index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}
                        </Option>
                    </Select>
                </div>
                <Button type="primary" v-if="buttonMenu['/type/view']" @click="getData()">查询</Button>
                <Button @click="handleReset()">重置</Button>
            </div>
            <div><Button type="primary" v-if="buttonMenu['/type/add']" @click="handleOpenEditModal()">添加</Button></div>
        </div>
        <div style="height: 100%;overflow:auto">
            <Table :data="tableData" :columns="columns">
                <template #status="{ row }">
                    <div>
                        <i-switch v-if="buttonMenu['/type/switch/1']" :value="row.typeStatus"
                            :before-change="() => handleChangeStatus(row)" @on-change="row.typeStatus = $event"></i-switch>
                        <span v-else>{{ row.typeStatus ? '开启' : '禁用' }}</span>
                    </div>
                </template>
                <template #action="{ row }">
                    <div>
                        <a style="margin-left: 10px;" v-if="buttonMenu['/type/edit']"
                            @click="handleOpenEditModal(row)">编辑</a>
                        <Poptip confirm title="确定要删除吗？" v-if="buttonMenu['/type/delete']" transfer
                            @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>

                    </div>
                </template>
                <Pages slot="footer" :page="page" :func="getData"></Pages>
            </Table>
        </div>

        <Modal v-model="editVisible" :title="(form.id ? '编辑' : '新增') + '分类'">
            <Form @submit.native.prevent :label-width="100" :model="form" ref="formRef" v-if="editVisible">
                <FormItem label="分类名称：" prop="typeName" :rules="[{ required: true, message: '请输入分类名称' }]">
                    <Input :maxlength="30" v-model="form.typeName"
                        @on-blur="form.typeName = limitstr(form.typeName, 30)" />
                </FormItem>
                <FormItem label="中文名称：" :rules="[{ required: true, message: '请输入中文名称' }]" >
                    <Input :maxlength="30" v-model="form.typeNameCn"
                        @on-blur="form.typeNameCn = limitstr(form.typeNameCn, 30)" />
                </FormItem>
                <FormItem label="排序值：" prop="typeSort" :rules="[{ required: true, message: '请输入排序值' }]">
                    <InputNumber :min="0" v-model="form.typeSort" :max="99999" />
                </FormItem>
                <FormItem label="分类状态：" prop="typeStatus" :rules="[{ required: true, message: '请选择' }]">
                    <i-switch v-model="form.typeStatus" />
                </FormItem>
                <FormItem label="所属语言：" prop="langId" :rules="[{ required: true, message: '请选择所属语言' }]">
                    <Select v-model="form.langId" placeholder="请选择语言">
                        <Option v-for="(item, index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}
                        </Option>
                    </Select>
                </FormItem>

            </Form>
            <template #footer>
                <Button @click="editVisible = false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getTypeList, addType, delType, editType, getTypeInfo, changeTypeStatus } from '@/api/channel'
import { getLangList } from '../../api/lang'
import { limitstr } from '../../libs/util'

export default {
    components: {
        Pages
    },
    data() {
        return {
            editVisible: false,
            limitstr,
            form: {
                typeSort: 0
            },
            searchForm: {},
            submitLoading: false,
            page: {
                current: 1,
                size: 10,
                total: 0
            },
            tableData: [],
            columns: [
                // {
                //   title: 'id',
                //   key: 'id'
                // },
                {
                    title: '分类名称',
                    key: 'typeName'
                },
                {
                    title: '中文名称',
                    key: 'typeNameCn'
                },
                {
                    title: '排序值',
                    key: 'typeSort'
                },
                {
                    title: '状态',
                    key: 'typeStatus',
                    slot: 'status'
                },
                {
                    title: '所属语言',
                    key: 'langName'
                },
                {
                    title: '创建人',
                    key: 'createUserName'
                },
                {
                    title: '创建时间',
                    key: 'createTimeFmt'
                },
                {
                    title: '修改人',
                    key: 'updateUserName'
                },
                {
                    title: '修改时间',
                    key: 'updateTimeFmt'
                },
                {
                    title: '操作',
                    align: 'center',
                    slot: 'action'
                }
            ],
            langList: []
        }
    },
    computed: {
        buttonMenu() {
            const li = this.$store.getters.getMenuRules('tags/channel')
            const obj = {}
            li.forEach(i => {
                obj[i.menuPath] = true
            })
            return obj
        }
    },
    methods: {
        getData(page) {
            if (page) this.page.current = page
            else this.page.current = 1
            getTypeList({
                ...this.page,
                ...this.searchForm
            }).then(({ data }) => {
                console.log(data)

                this.tableData = data.records
                this.page.current = data.current
                this.page.total = data.total
            })
        },
        async handleOpenEditModal(row) {
            if (row) {
                const r = await getTypeInfo(row.id)
                this.form = r.data
            } else {
                this.form = {
                    typeStatus: false,
                    typeSort: 0
                }
            }
            this.editVisible = true
        },
        handleChangeStatus(row) {
            changeTypeStatus(row.id).then(r => {
                this.$Message.success('操作成功')
                this.getData(this.page.current)
            }).catch(e => {
                this.$Message.error('操作失败')
            })
            return new Promise(() => { })
        },
        handleSubmit() {
            this.$refs.formRef.validate(r => {
                if (r) {
                    const func = this.form.id ? editType : addType
                    this.submitLoading = true
                    func({
                        ...this.form
                    }).then(r => {
                        this.$Message.success('操作成功')
                        this.getData()
                        this.submitLoading = false
                        this.editVisible = false
                    }).catch(() => {
                        this.submitLoading = false
                    })
                }
            })
        },
        handleDel(row) {
            delType(row.id).then(r => {
                this.$Message.success('操作成功')
                this.getData()
            })
        },
        handleReset() {
            this.searchForm = {}
        },
        handleGetLang() {
            getLangList({ current: -1, size: -1, 
                // langStatus: true
             }).then(r => {
                this.langList = r.data.records
            })
        }
    },
    mounted() {
        this.getData()
        this.handleGetLang()
    }
}
</script>

<style scoped lang="less">
.search-form {
    display: flex;

    &>* {
        margin: 0 5px;
    }
}

.layout-card {
    /deep/ .ivu-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
}
</style>
